<template>
<v-flex md12 sm12 xs12>
  <v-expansion-panel class="no-shadow card-r">
    <v-expansion-panel-content class="grey lighten-3">
      <div style="color: #2971a3" class="f-12" slot="header"> School Open Days & times</div>
      <v-card class="grey lighten-3">
        <v-layout xs12 lg12>
          <v-flex xs4 class="px-2">
            <v-checkbox color="primary" label="Monday"></v-checkbox>
          </v-flex>
          <v-flex xs4 class="px-2">
            <div class="f-10 pa-0 ma-0">Start Time </div>
            <time-picker/>
          </v-flex>
          <v-flex xs4 class="px-2" >
            <div class="f-10 pa-0 ma-0"> End Time</div>
            <time-picker/>
          </v-flex>
        </v-layout>
        <v-layout xs12 lg12>
          <v-flex xs4 class="px-2">
            <v-checkbox color="primary" label="Tuesday"></v-checkbox>
          </v-flex>
          <v-flex xs4 class="px-2">
            <div class=" f-10 pa-0 ma-0 mt-3"> </div>
            <time-picker/>
          </v-flex>
          <v-flex xs4 class="px-2" >
            <div class=" f-10 pa-0 ma-0 mt-3"> </div>
            <time-picker/>
          </v-flex>
        </v-layout>
        <v-layout xs12 lg12>
          <v-flex xs4 class="px-2">
            <v-checkbox color="primary" label="Wednesday"></v-checkbox>
          </v-flex>
          <v-flex xs4 class="px-2">
            <div class=" f-10 pa-0 ma-0 mt-3"> </div>
            <time-picker/>
          </v-flex>
          <v-flex xs4 class="px-2" >
            <div class=" f-10 pa-0 ma-0 mt-3"> </div>
            <time-picker/>
          </v-flex>
        </v-layout>
        <v-layout xs12 lg12>
          <v-flex xs4 class="px-2">
            <v-checkbox color="primary" label="Thursday"></v-checkbox>
          </v-flex>
          <v-flex xs4 class="px-2">
            <div class=" f-10 pa-0 ma-0 mt-3"> </div>
            <time-picker/>
          </v-flex>
          <v-flex xs4 class="px-2" >
            <div class=" f-10 pa-0 ma-0 mt-3"> </div>
            <time-picker/>
          </v-flex>
        </v-layout>
        <v-layout xs12 lg12>
          <v-flex xs4 class="px-2">
            <v-checkbox color="primary" label="Friday"></v-checkbox>
          </v-flex>
          <v-flex xs4 class="px-2">
            <div class=" f-10 pa-0 ma-0 mt-3"> </div>
            <time-picker/>
          </v-flex>
          <v-flex xs4 class="px-2" >
            <div class=" f-10 pa-0 ma-0 mt-3"> </div>
            <time-picker/>
          </v-flex>
        </v-layout>
        <v-layout xs12 lg12>
          <v-flex xs4 class="px-2">
            <v-checkbox color="primary" label="Saturday"></v-checkbox>
          </v-flex>
          <v-flex xs4 class="px-2">
            <div class=" f-10 pa-0 ma-0 mt-3"> </div>
            <time-picker/>
          </v-flex>
          <v-flex xs4 class="px-2" >
            <div class=" f-10 pa-0 ma-0 mt-3"> </div>
            <time-picker/>
          </v-flex>
        </v-layout>
        <v-layout xs12 lg12>
          <v-flex xs4 class="px-2">
            <v-checkbox color="primary" label="Sunday"></v-checkbox>
          </v-flex>
          <v-flex xs4 class="px-2">
            <div class=" f-10 pa-0 ma-0 mt-3"> </div>
            <time-picker/>
          </v-flex>
          <v-flex xs4 class="px-2" >
            <div class=" f-10 pa-0 ma-0 mt-3"> </div>
            <time-picker/>
          </v-flex>
        </v-layout>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</v-flex>
</template>
<script>
  /* eslint-disable */
  import TimePicker from "./TimePicker"
  export default {
    data: () => ({
      time: null,
      menu2: false,
    }),
    components: {
      TimePicker
    }
  };
</script>
<style>
  .v-expansion-panel__header{
    padding: 0px !important;
    margin: 10px 0px 10px 0px !important;
  }
  .theme--light.v-expansion-panel .v-expansion-panel__container .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon{
    font-size: 15px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/OpenDays.vue